import backend from '@common/backend';

const BASE = '/locations';

export interface IGetLocationsQuery {
	type?: string;
	search?: string;
	page?: number;
	limit?: number;
	service_id?: number;
	is_meet?: number;
	c_g_counselor_id?: number;
}

export interface IGetLocationQuery {
	type?: string;
	is_meet?: number;
	service?: number;
	service_id?: number;
}

export const getLocations = async (query: IGetLocationsQuery) =>
	backend.get(`${BASE}/`, {
		params: query,
	});

export const createLocation = async (data: any) => backend.post(`${BASE}`, data);

export const getLocation = async (id: number, params?: IGetLocationQuery) =>
	backend.get(`${BASE}/${id}`, { params });

export const saveLocation = async (id: number, data: any) => backend.put(`${BASE}/${id}`, data);

export const attachTeachers = async (locationId: number, teacher_ids: number[]) => backend.patch(`${BASE}/${locationId}/teachers`, {
	teacher_ids,
});
